import { DocsBlockPropertyDefinition, } from "../properties/SDKDocsBlockProperty";
import { DocsBlockVariant } from "./SDKDocsBlockVariant";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsBlockItemDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d;
        this.properties = model.properties.map((propertyModel) => new DocsBlockPropertyDefinition(propertyModel));
        this.appearance = {
            isBordered: (_b = (_a = model.appearance) === null || _a === void 0 ? void 0 : _a.isBordered) !== null && _b !== void 0 ? _b : true,
            hasBackground: (_d = (_c = model.appearance) === null || _c === void 0 ? void 0 : _c.hasBackground) !== null && _d !== void 0 ? _d : false,
        };
        this.variants = model.variants.map((v) => new DocsBlockVariant(v));
        this.defaultVariantKey = model.defaultVariantKey;
    }
}
